import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Select } from '@blueprintjs/select'
import { Button } from '@blueprintjs/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'

import styles from './buttonSelect.module.scss'

class ButtonSelect extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        icon: PropTypes.object,
        className: PropTypes.string,
        selectedLabel: PropTypes.string.isRequired,
    }

    render() {
        const { label, icon, className, selectedLabel, ...others } = this.props

        return (
            <div
                className={classNames(styles.buttonSelect, {
                    [className]: className,
                })}
            >
                <Select
                    filterable={false}
                    popoverProps={{
                        minimal: true,
                        position: 'bottom-right',
                    }}
                    {...others}
                >
                    <Button className={styles.button} minimal>
                        {icon ? (
                            <FontAwesomeIcon
                                className={styles.leftIcon}
                                icon={icon}
                            />
                        ) : null}
                        <span className={styles.label}>{label}:</span>
                        <span className={styles.value}>{selectedLabel}</span>
                        <FontAwesomeIcon
                            icon={faChevronDown}
                            className={styles.rightIcon}
                        />
                    </Button>
                </Select>
            </div>
        )
    }
}

export default ButtonSelect
